import type { recipe } from '../../../utils/recipeUtils'
import '../ListEntry.scss'
import './RecipeEntry.scss'

interface RecipeEntryProps {
  recipe: recipe
  isMobile: boolean
  openPopup: (recipe: recipe | null) => void
}

function RecipeEntry({ recipe, isMobile, openPopup }: RecipeEntryProps) {
  const subClass = recipe.type ? recipe.type.toLowerCase() : 'otros'

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 60)
    const minutes = (time % 60).toString().padStart(2, '0')

    return `${hours} h ${minutes} min`
  }

  const onClick = () => {
    openPopup(recipe)
  }

  return (
    <div
      key={recipe.id}
      className={`list-entry recipe-type-${subClass} ${isMobile ? 'list-entry-mobile' : ''}`}
      onClick={onClick}
    >
      <div className="recipe-name">
        <span>{recipe.name}</span>
      </div>
      <div className="recipe-type">
        <span>{recipe.type}</span>
      </div>
      <div className="recipe-storage-qty">
        <span>{recipe.storage_qty}</span>
      </div>
      <div className="recipe-time">
        <span>{formatTime(recipe.time)}</span>
      </div>
    </div>
  )
}

export default RecipeEntry
